import { TFunction } from "i18next";

import { ListEventsRequest } from "shared/api/api";
import { Claim } from "shared/api/claims/api";
import { useListClaims } from "shared/api/claims/hooks";
import { UseAPIState } from "shared/api/hooks";
import { PinType } from "shared/api/issues/api";
import { SignalEventsOccurrence } from "shared/api/signalEvents/api";
import { useListSignalEventsOccurrences } from "shared/api/signalEvents/hooks";
import { EventTypeEnum } from "shared/types";

const INVESTIGATOR_URL_KEY = "investigator";

export const INVESTIGATOR_EVENT_FILTER_KEY = `${INVESTIGATOR_URL_KEY}-event-filter`;
export const INVESTIGATOR_VEHICLE_FILTER_KEY = `${INVESTIGATOR_URL_KEY}-vehicle-filter`;
export const INVESTIGATOR_NAVIGATED_FROM_KEY = `${INVESTIGATOR_URL_KEY}-navigated-from`;
export const INVESTIGATOR_EVENT_TYPE_KEY = `${INVESTIGATOR_URL_KEY}-event-type`;
export const INVESTIGATOR_VIEW_TITLE_KEY = `${INVESTIGATOR_URL_KEY}-view-title`;

export const INVESTIGATOR_EVENT_FILTER = "investigator-event-filter";
export const INVESTIGATOR_VEHICLE_FILTER = "investigator-vehicle-filter";
export const INVESTIGATOR_EVENT_TYPE = "investigator-event-type";

export const getPinTypeDefaultTitle = (type: PinType, t: TFunction): string => {
  const keys: Record<PinType, string> = {
    [PinType.TABLE]: "investigator.pin_title_related_records",
    [PinType.TOP_CONTRIBUTORS]: "investigator.pin_title_top_contributors",
    [PinType.BY_VEHICLE_AGE]: "investigator.pin_title_production_date",
    [PinType.RUN_CHART]: "investigator.pin_title_occurrence_date",
  };

  return t(keys[type]);
};

export const getAnalyzeLabel = (
  eventType: EventTypeEnum,
  t: TFunction
): string | undefined => {
  const keys: Partial<Record<EventTypeEnum, string>> = {
    [EventTypeEnum.CLAIM]: "investigator.analyze_claims",
    [EventTypeEnum.SIGNAL_EVENT]: "investigator.analyze_signal_events",
  };
  const key = keys[eventType];

  return key ? t(key) : undefined;
};
export const USE_EVENT_LIST_HOOK_MAPPING: Partial<
  Record<
    EventTypeEnum,
    (
      props: ListEventsRequest
    ) => UseAPIState<Claim[] | SignalEventsOccurrence[]>
  >
> = {
  [EventTypeEnum.CLAIM]: (props: ListEventsRequest) => useListClaims(props),
  [EventTypeEnum.SIGNAL_EVENT]: (props: ListEventsRequest) =>
    useListSignalEventsOccurrences(props),
};

export const getStaticPinOptions = (t: TFunction) => [
  {
    ID: "new run chart",
    createdAt: "",
    updatedAt: "",
    issueID: "new",
    type: PinType.RUN_CHART,
    data: {
      options: undefined,
    },
    title: getPinTypeDefaultTitle(PinType.RUN_CHART, t),
  },
  {
    ID: "new by vehicle age",
    createdAt: "",
    updatedAt: "",
    issueID: "new",
    title: getPinTypeDefaultTitle(PinType.BY_VEHICLE_AGE, t),
    type: PinType.BY_VEHICLE_AGE,
    data: {
      options: undefined,
    },
  },
];
